import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Dropdown/Dropdown';
import HeaderTopDropdownItem from './HeaderTopDropdownItem';
import HeaderTopDropdownNestedItem from './HeaderTopDropdownNestedItem';

const HeaderTopDropdown = ({ children, ariaLabel, ...rest }) => <li className="o-list-inline__item c-header-top__item">
    <Dropdown
      ariaLabel={ariaLabel}
      btnClassName="c-header-top__link"
      className="c-header-dropdown"
      color="subtle"
      dropdownMenuClassName="c-header-dropdown__menu"
      position="right"
      {...rest}
    >
      <ul className="o-list-bare c-header-dropdown__list u-margin-bot-none">
        {children}
      </ul>
    </Dropdown>
  </li>

HeaderTopDropdown.Item = HeaderTopDropdownItem;
HeaderTopDropdown.NestedItem = HeaderTopDropdownNestedItem;

export default HeaderTopDropdown;

HeaderTopDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};
